import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeadsetIcon from '@mui/icons-material/Headset';
import './index.css';

// Floating contact button shown on user pages
const StickyContactButton = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Monitor DOM mutation to detect if curriculum sidebar is open
  useEffect(() => {
    const checkSidebar = () => {
      const sidebar = document.querySelector('.curriculum-sidebar');
      setIsSidebarOpen(sidebar?.classList.contains('open') ?? false);
    };

    checkSidebar();

    const bodyObserver = new MutationObserver(() => {
      const sidebar = document.querySelector('.curriculum-sidebar');
      if (!sidebar) {
        setIsSidebarOpen(false);
        return;
      }

      const checkSidebarClass = () => setIsSidebarOpen(sidebar.classList.contains('open'));
      checkSidebarClass();

      sidebarObserver.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
    });

    const sidebarObserver = new MutationObserver(() => checkSidebar());
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      bodyObserver.disconnect();
      sidebarObserver.disconnect();
    };
  }, []);

  // Smooth scroll to the contact form section
  const scrollToContact = () => {
    if (location.pathname !== '/') {
      window.location.href = '/#contact-form';
      return;
    }

    const formElement = document.getElementById('contact-form');
    const sectionElement = document.getElementById('contact');
    const targetElement = formElement || sectionElement;

    if (targetElement) {
      const offset = 100;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, offsetPosition), behavior: 'smooth' });
    } else {
      setTimeout(() => {
        const retryFormElement = document.getElementById('contact-form');
        const retrySectionElement = document.getElementById('contact');
        const retryTarget = retryFormElement || retrySectionElement;

        if (retryTarget) {
          const offset = 100;
          const elementPosition = retryTarget.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, offsetPosition), behavior: 'smooth' });
        }
      }, 300);
    }
  };

  // Hide button on admin dashboard or when curriculum sidebar is expanded
  if (location.pathname === '/admin-dashboard' || isSidebarOpen) return null;

  return (
    <button type="button" className="sticky-contact-button" onClick={scrollToContact} aria-label="Contact Us">
      <span className="icon-wrapper">
        <HeadsetIcon sx={{ fontSize: 32, color: '#000000' }} />
      </span>
    </button>
  );
};

export default StickyContactButton;